// extracted by mini-css-extract-plugin
module.exports = {"container":"SayveStandbyBanner_container__3LL4q","wrap":"SayveStandbyBanner_wrap__1eywn","sub":"SayveStandbyBanner_sub__16xZ8","content":"SayveStandbyBanner_content__O0qBO"};